import Button, { ButtonProps } from "@mui/material/Button";
import { ElementType } from "react";

/** Extends MUI Button props with common polymorphic link fields. */
export type AppButtonProps = ButtonProps & {
  component?: ElementType;
  to?: string;
  href?: string;
};

/**
 * Shared button. Theme defaults (height, radius, sentence case, no elevation)
 * come from ThemeManager; this wrapper is the single import path for pages.
 */
export function AppButton({
  disableElevation = true,
  ...props
}: AppButtonProps) {
  return <Button disableElevation={disableElevation} {...props} />;
}

export default AppButton;
